export function initializeContactModul() {
    const triggerBtn = document.getElementById('trigger-action-sheet');
    const sheet = document.getElementById('action-sheet');
    const overlay = document.getElementById('action-sheet-overlay');
    const closeBtn = document.querySelector('.sheet-close');
    
    // Accessibility: Elemente die den Fokus fangen sollen
    const focusableElementsString = 'a[href], button:not([disabled])';
    const focusableElements = sheet.querySelectorAll(focusableElementsString);
    const firstTabStop = focusableElements[0]; // Close Button meistens
    const lastTabStop = focusableElements[focusableElements.length - 1];

    function openSheet() {
        sheet.classList.add('is-active');
        sheet.setAttribute('aria-hidden', 'false');
        overlay.classList.add('is-active');
        overlay.setAttribute('aria-hidden', 'false');
        
        // Fokus auf Close Button setzen
        setTimeout(() => {
            if (closeBtn) closeBtn.focus();
        }, 100);
        
        // Body Scroll verhindern (optional, aber gut für UX)
        document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
        sheet.classList.remove('is-active');
        sheet.setAttribute('aria-hidden', 'true');
        overlay.classList.remove('is-active');
        overlay.setAttribute('aria-hidden', 'true');
        
        // Fokus zurück zum Trigger Button
        if (triggerBtn) triggerBtn.focus();
        
        document.body.style.overflow = '';
    }

    // Event Listeners
    if (triggerBtn) {
        triggerBtn.addEventListener('click', openSheet);
    }
    
    if (closeBtn) {
        closeBtn.addEventListener('click', closeSheet);
    }

    if (overlay) {
        overlay.addEventListener('click', closeSheet);
    }

    // Escape Key zum Schließen
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && sheet.classList.contains('is-active')) {
            closeSheet();
        }
    });

    // Focus Trap im Modal (Damit man nicht dahinter tabben kann)
    sheet.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
            if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstTabStop) {
                    e.preventDefault();
                    lastTabStop.focus();
                }
            } else { // Tab
                if (document.activeElement === lastTabStop) {
                    e.preventDefault();
                    firstTabStop.focus(); // Zurück zum Anfang (Close Button)
                }
            }
        }
    });
}